<template>
    <div class="error-block" :class="{ 'another' : notTR }">
        <div class="error-cont">
            <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <path id="Path_3937" data-name="Path 3937" d="M10,20A10,10,0,1,0,0,10,10,10,0,0,0,10,20ZM10,4.167a1.25,1.25,0,1,1-1.25,1.25A1.25,1.25,0,0,1,10,4.167ZM9.167,8.333H10A1.667,1.667,0,0,1,11.667,10v5A.833.833,0,0,1,10,15V10H9.167a.833.833,0,0,1,0-1.667Z" fill="#fff"/>
                </svg>
            </div>
            <span class="light-italic">{{ $fn.tr(text) }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            required: true,
            type: String
        },
        notTR: {
            type: Boolean
        }
    },
    data() {
        return {

        }
    }
}
</script>

<style>

.error-block .error-cont {
    display: flex;
    align-items: center;
    border: 1px solid #FFFFFF;
    padding-left: 34px;
    padding-top: 24px;
    padding-bottom: 24px;
    padding-right: 34px;
    background-color: rgb(255, 255, 255, 0.3);
}
.error-block.another .error-cont {
    border: 1px solid black;
    background-color: rgb(3, 84, 31, 0.6);
}
.error-block .error-cont .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
}
.error-block .error-cont span {
    font-size: 21px;
    color: white;
}
@media (max-width: 767px) {
    .error-block .error-cont {
        padding-left: 15px;
        padding-right: 15px;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .error-block .error-cont span {
        font-size: 18px;
    }
}

</style>